import Vue from 'vue'
import App from './App.vue'
import * as VueGoogleMaps from "vue2-google-maps"; // https://alligator.io/vuejs/vue-google-maps/
import axios from 'axios' // Lecture 346

import Vuelidate from 'vuelidate'; // Lecture 373, https://vuelidate.js.org/#sub-package-content
import VModal from 'vue-js-modal' // https://www.npmjs.com/package/vue-js-modal
import Multiselect from 'vue-multiselect' // https://vue-multiselect.js.org/

import router from './router'
import store from './store/store';

// import CKEditor from '@ckeditor/ckeditor5-vue'; // https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/frameworks/vuejs.html
// import VueCkeditor from 'vueckeditor';

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
  apiKey: '064ad86b5826cf0d0bebff2c2d469df7',
  plugins: [new BugsnagPluginVue()]
})

Bugsnag.getPlugin('vue')
  .installVueErrorHandler(Vue)

import VueYouTubeEmbed from 'vue-youtube-embed' // https://www.npmjs.com/package/vue-youtube-embed

// https://vsupalov.com/avoid-csrf-errors-axios-django/
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"

// axios.defaults.baseURL = 'http://127.0.0.1:8000' // Lecture 346
axios.defaults.baseURL = 'https://enginehire.io' // Lecture 346

// Lecture 349
// https://stackoverflow.com/questions/43051291/attach-authorization-header-for-all-axios-requests
axios.interceptors.request.use(config => {
  console.log('Request Interceptor', config)
  // console.log(store.state.userToken)
  // console.log(localStorage.getItem('token'))
  if (localStorage.getItem('token')) {
    config.headers['Authorization'] = 'Token ' + localStorage.getItem('token')
  }
  return config
})

Vue.use(Vuelidate); // Lecture 373, https://vuelidate.js.org/#sub-package-content
Vue.use(VModal) // https://www.npmjs.com/package/vue-js-modal
Vue.component('multiselect', Multiselect) // https://vue-multiselect.js.org

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAjRmYdMmC9yr1dP8Kqi7FPS_8_CsvT2qc",
    libraries: "places" // necessary for places input
  }
});

// Vue.use( CKEditor );
// Vue.use( VueCkeditor );

Vue.use(VueYouTubeEmbed)

// https://scotch.io/tutorials/how-to-create-filters-in-vuejs-with-examples
Vue.filter("trimSeconds", function (value) { // Used for trimming the seconds off an event time (turn 18:00:00 into 18:00)
  return value.slice(0, -3); // https://stackoverflow.com/questions/952924/javascript-chop-slice-trim-off-last-character-in-string
});
// https://stackoverflow.com/questions/44538110/how-to-format-numbers-in-vuejs
// http://numeraljs.com/
var numeral = require("numeral");
Vue.filter("singleDecimal", function(value) {
  // Used for making something 1 decimal (good for actual distances)
  return numeral(value).format("0.0");
});

// https://vuejs.org/v2/guide/mixins.html#Global-Mixin
// https://stackoverflow.com/questions/42613061/vue-js-making-helper-functions-globally-available-to-single-file-components
Vue.mixin({
  data() {
    return {
      justTesting: 'jsfkhg'
    }
  },
  computed: {
    todayDjangoFormat() { // Want to get today's date in the YYYY-MM-DD format for comparison with django dates
      let today = new Date()
      return today.getFullYear().toString() +
      '-' + ('0' + (today.getMonth()+1).toString()).slice(-2) +
      '-' + ('0' + today.getDate().toString()).slice(-2)
    },
    todayDatetimeDjangoFormat() { // Want to get today's date in the YYYY-MM-DD format for comparison with django dates
      let today = new Date()
      return today.getFullYear().toString() +
      '-' + ('0' + (today.getMonth()+1).toString()).slice(-2) +
      '-' + ('0' + today.getDate().toString()).slice(-2) +
      'T' + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds()
    },
    editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    checkInteger(userinput) {
      //
      // Using this function to check if a user has entered an integer in number fields and display an error message if not
      //

      // Don't want to show an error if the field is blank
      if (userinput == null || userinput == '') {
        return false
      }

      // https://stackoverflow.com/questions/1779013/check-if-string-contains-only-digits
      console.log(userinput)
      // console.log(Number.isInteger(userinput))
      // console.log(!isNaN(userinput)) // https://www.mkyong.com/javascript/check-if-variable-is-a-number-in-javascript/
      console.log(/^\d+$/.test(userinput))
      if (/^\d+$/.test(userinput)) {
        console.log('Is an integer!')
        return false
      }
      else {
        console.log('Is not an integer')
        return true
      }
    },
    dateInDjangoFormat(date) {
      // Want to convert date in the YYYY-MM-DD format for Django storage
      return (
        date.getFullYear().toString() +
        "-" +
        ("0" + (date.getMonth() + 1).toString()).slice(-2) +
        "-" +
        ("0" + date.getDate().toString()).slice(-2)
      );
    },
    addCurrentTimeToDate(date) {
      let today = new Date()
      let hourNow = today.getHours()
      // https://stackoverflow.com/questions/18889548/javascript-change-gethours-to-2-digit
      // Need to make sure each of these values is 2 digits, otherwise it breaks the human date generation below
      hourNow = ("0" + hourNow).slice(-2);
      let minuteNow = today.getMinutes()
      minuteNow = ("0" + minuteNow).slice(-2);
      let secondNow = today.getMinutes()
      secondNow = ("0" + secondNow).slice(-2);

      return new Date(date.concat('T').concat(hourNow).concat(':').concat(minuteNow).concat(':').concat(secondNow))
    },
    convertTimeFormat(str) {
      //convert AM/PM to military time (ie. 19:00:00)
      console.log(str)
      let time = str;
      let hours = Number(time.match(/^(\d+)/)[1]);
      let minutes = Number(time.match(/:(\d+)/)[1]);
      let AMPM = time.match(/\s(.*)$/)[1];
      if (AMPM == "PM" && hours < 12) hours = hours + 12;
      if (AMPM == "AM" && hours == 12) hours = hours - 12;
      let sHours = hours.toString();
      let sMinutes = minutes.toString();
      if (hours < 10) sHours = "0" + sHours;
      if (minutes < 10) sMinutes = "0" + sMinutes;
      return `${sHours}:${sMinutes}:00`;
    },
    // https://stackoverflow.com/questions/8888491/how-do-you-display-javascript-datetime-in-12-hour-am-pm-format
    formatAMPM(date) {
      // Take a javascript date and spit out the time in AMPM format
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    djangotimeformatAMPM(djangotime) {
      // Take a django 24 hour time and return it in AMPM format
      // console.log(djangotime)
      if (djangotime) {
        var hours = djangotime.split(":")[0];
        var minutes = djangotime.split(":")[1];
        var ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        // minutes = minutes < 10 ? '0'+minutes : minutes; // minutes are already padded in django time
        var strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
      }
      else {
        return strTime;
      }
    },
    getAge(birthday) {
        var today = new Date();
        var birthDate = new Date(birthday);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
        {
            age--;
        }
        return age;
    },
    // https://stackoverflow.com/questions/1026069/how-do-i-make-the-first-letter-of-a-string-uppercase-in-javascript
    // Used for trying to seamlessly log people in with capitalized email addresses
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  }
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js